import React, { memo, useCallback } from 'react';
import BookingFormStore from 'Stores/BookingFormStore';
import Button from '@material-ui/core/Button';
import LinkedInButton from 'Pure/LinkedInButton';
import GoogleButton from 'Pure/GoogleButton';
import MyWOIcon from 'Icons/myWO';
import bemit from 'Functions/bemit';
import { action } from 'Shared/Routes';
export default memo(function BookingSignIn({
  ...props
}) {
  const oauth_register = BookingFormStore.useState(s => s.oauth_register);
  const subscribed = BookingFormStore.useState(s => s.newsletter_subscription);
  const is__auth = BookingFormStore.useState(s => s.logged_in);
  const error = BookingFormStore.useState(s => s.oauth_login_error);
  const step = BookingFormStore.useState(s => s.step);
  const source = BookingFormStore.useState(s => s.source);
  const lkin_loading = BookingFormStore.useState(s => s.linkedin_redirecting);
  const goog_loading = BookingFormStore.useState(s => s.google_redirecting);
  const signIn = useCallback(function (e, strategy) {
    BookingFormStore.update(function (store) {
      store.oauth_register_error = undefined;
      store[strategy + '_redirecting'] = true;
      store.oauth_strategy = strategy;
    });
    window.setTimeout(function () {
      let new_url = [document.location.origin, action('PassportAuth'), '?source=', source || 'FrontBookingPage', '&strategy=' + strategy].join('');
      if (subscribed) new_url += '&newsletter=true';
      document.location.href = new_url;
    }, 250);
  }, [subscribed, source]);
  const signInWithLinkedIn = useCallback(function (e) {
    signIn(e, 'linkedin');
  }, [signIn]);
  const signInWithGoogle = useCallback(function (e) {
    signIn(e, 'google');
  }, [signIn]);
  const openLoginModal = useCallback(function (e) {
    e.persist();
    BookingFormStore.update(function (store) {
      store.login_modal_trigger = e.target;
      store.login_modal = true;
      store.oauth_register_error = undefined;
    });
  }, []);
  if (step !== 1 || is__auth || oauth_register) return null;
  return /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__step"
  }, /*#__PURE__*/React.createElement("h3", {
    className: "c-booking-auth__title"
  }, "D\xE9j\xE0 client"), /*#__PURE__*/React.createElement("p", {
    className: "c-booking-auth__txt"
  }, "Connectez-vous et retrouvez toutes vos informations pr\xE9-remplies pour gagner du temps."), /*#__PURE__*/React.createElement("div", {
    className: "c-booking-auth__buttons"
  }, /*#__PURE__*/React.createElement(Button, {
    className: bemit('c-flat-btn', ['myWO', 'logo']) + ' u-margin-bottom-25',
    onClick: openLoginModal
  }, /*#__PURE__*/React.createElement(MyWOIcon, {
    className: "c-flat-btn__icon"
  }), "Se connecter avec myWO"), props['linkedIn'] === true ? /*#__PURE__*/React.createElement(LinkedInButton, {
    onClick: signInWithLinkedIn,
    loading: lkin_loading === true,
    className: "u-margin-top-0 u-margin-bottom-25"
  }) : undefined, props['google'] === true ? /*#__PURE__*/React.createElement(GoogleButton, {
    onClick: signInWithGoogle,
    loading: goog_loading === true,
    className: "u-margin-top-0 u-margin-bottom-0"
  }) : undefined, error ? /*#__PURE__*/React.createElement("div", {
    className: bemit('c-message', ['v2', 'red']) + ' u-margin-top-40'
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-message__content"
  }, error)) : undefined));
});
